
const supportedAuthProvider = ["google.com", "facebook.com", "twitter.com"];

function isUserVerified(user) {
	if (!user || !user.user_id) {
		//Anonymous User
		return false;
	} else {
		if (supportedAuthProvider.includes(user.provider)) {
			return true;
		}
		const isVerified = user.isVerified;
		console.log("user:", user);
		console.log("isUserVerified:", isVerified);
		return user.isVerified;
	}
}

function isUserAnonymous(user) {
	if (!user || !user.user_id) {
		//Anonymous User
		return true;
	} 
	return false;
}

export {
	isUserVerified,
	isUserAnonymous
}